export default __webpack_public_path__ + "static/media/modal_Vektoriserad.3e80161c.png";